import { Link } from "react-router-dom";

import eabLogoHorizontal from "@/assets/eab-logo-horizontal.png";

import { PillLink } from "./PillLink";
import { routes } from "./landingContent";

/**
 * Landing page header: white bar, logo on the left, centered site name, and
 * News + sign in + Join us on the right.
 *
 * Nav is intentionally just "News" — the handoff removed the Programs, Mentors
 * and About links rather than leaving them to be filled in later.
 */
export default function LandingHeader() {
  return (
    <header className="bg-white">
      {/* Everything is nowrap and scaled down below lg: at 375px the items
          otherwise wrap mid-label and triple the bar's height. */}
      <div className="mx-auto flex w-full max-w-[1440px] items-center justify-between gap-3 px-4 py-5 lg:gap-4 lg:pl-8 lg:pr-10">
        {/* Left: logo */}
        <Link to="/" className="flex shrink-0 items-center" aria-label="EAB Connect home">
          <img
            src={eabLogoHorizontal}
            alt=""
            className="h-6 w-auto lg:h-8"
          />
        </Link>

        {/* Center: site name */}
        <div className="min-w-0 flex-1 text-center">
          <span className="whitespace-nowrap text-[22px] font-bold tracking-[-0.02em] text-eab-neutral-900 lg:text-[30px]">
            EAB Connect
          </span>
        </div>

        {/* Right: News, Sign in, Join us */}
        <div className="flex shrink-0 items-center gap-2 lg:gap-4">
          <Link
            to={routes.news}
            className="whitespace-nowrap text-[14px] font-medium text-eab-neutral-700 transition-colors hover:text-eab-blue lg:text-[16px]"
          >
            News
          </Link>
          <Link
            to={routes.signIn}
            className="whitespace-nowrap text-[14px] font-medium text-eab-neutral-700 transition-colors hover:text-eab-blue lg:text-[16px]"
          >
            Sign in
          </Link>
          <PillLink
            to={routes.signUp}
            variant="greenDark"
            className="whitespace-nowrap px-4 py-2 text-[15px] lg:px-6 lg:py-[11px] lg:text-[16px]"
          >
            Join us
          </PillLink>
        </div>
      </div>
    </header>
  );
}
